var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 517,
    height: 1161,
    viewBox: "0 0 517 1161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3176_13510",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 517,
    height: 1161
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 517,
    height: 1161,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3176_13510)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3176_13510)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -122.8,
    cy: 484.397,
    rx: 251.108,
    ry: 204.096,
    transform: "rotate(-32.1355 -122.8 484.397)",
    fill: "#AEF8F8",
    fillOpacity: 0.52
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3176_13510",
    x: -861.598,
    y: -234.04,
    width: 1477.6,
    height: 1436.88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_3176_13510"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideGradient);
export default __webpack_public_path__ + "static/media/side_gradient.daa57aec1398f176902ac1fcecd32b85.svg";
export { ForwardRef as ReactComponent };